// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"85a89d6b","488":"4e8ddb2b","518":"1c15ebe3","664":"ca371ed3","891":"b0536ac6","913":"7b232c42"}[chunkId] + ".chunk.js";
};